import React from 'react'
import { useTranslation } from 'react-i18next'
import '../../LooseLineItem/loose-line-item.scss'
import downloadIcon from '../../../assets/images/downloadIcon.svg'

const DownloadPdf = () => {
	const { t } = useTranslation(["labels"]);
	return (
		<div className='ru-download-section'>
			<div className='ru-file-download'>
			<img
                        src={downloadIcon}
                        alt="download"
                        title="download"
                        id="download-icon"
                    />
			<a
				className='declaration_download_btn'
				href={process.env.PUBLIC_URL + '/RussiaDeclarationForm.pdf'}
				role='button'
				target="_blank"
				download		
			>
				{t('BOOKING.DOWNLOAD_RU_DECLARATION')}
			</a>
			</div>
		</div>
	)
}

export default DownloadPdf
